export default (store) => (next) => (action) => {
    const { meta } = action;
    if (meta) {
        const keys = Object.keys(meta);
        keys.forEach((key) => {
            switch (key) {
                case 'intercom':
                    // eslint-disable-next-line no-console
                    console.log(meta.intercom);
                    break;
                default:
                    break;
            }
        });
    }
    return next(action);
};
